'use strict';

import Media from '../../../js/imports/media.js';
import debounce from 'lodash.debounce';

class FullBgCta {
    internal;
    ui;
    wrap;

    constructor(options) {
        if (options.wrap) {
            this.wrap = options.wrap;
        }

        if (this.wrap) {
            this.internal = {
                imgSm: this.wrap.getAttribute('data-image-sm'),
                imgMd: this.wrap.getAttribute('data-image-md'),
                imgLg: this.wrap.getAttribute('data-image-lg'),
                imgSmLoaded: false,
                imgMdLoaded: false,
                imgLgLoaded: false,
                resizeTimeout: 0
            };

            this.ui = {
                imgSmEl: document.querySelector('.js-full-bg-cta__bg--sm'),
                imgMdEl: document.querySelector('.js-full-bg-cta__bg--md'),
                imgLgEl: document.querySelector('.js-full-bg-cta__bg--lg'),
                bgContainer: document.querySelector('.js-full-bg-cta__bg-container')
            };

            if (this.internal.imgSm && this.internal.imgMd && this.internal.imgLg) {

                this.internal.imgSm = encodeURI(this.internal.imgSm);
                this.internal.imgMd = encodeURI(this.internal.imgMd);
                this.internal.imgLg = encodeURI(this.internal.imgLg);

                if (this.ui.imgSmEl && this.ui.imgMdEl && this.ui.imgLgEl) {
                    this.loadImages();
                    this.bindUIActions();
                }
            }
        }
    }

    bindUIActions() {
        window.addEventListener('resize', () => this.windowResize());
    }

    windowResize() {
        this.loadImages();
    }

    loadImages() {
        if (!this.internal.imgSmLoaded || !this.internal.imgMedLoaded || !this.internal.imgLgLoaded) {
            var img = new Image();

            if ( !this.internal.imgSmLoaded && Media().init('mq-small') ) {
                // Load small image
                img.src = this.internal.imgSm;
                this.ui.imgSmEl.style.backgroundImage = 'url(' + img.src + ')' ;
                this.internal.imgSmLoaded = true;
            } else if ( !this.internal.imgMdLoaded && Media().init('mq-medium') ) {
                // Load medium image
                img.src = this.internal.imgMd;
                this.ui.imgMdEl.style.backgroundImage = 'url(' + img.src + ')' ;
                this.internal.imgMdLoaded = true;
            } else if ( !this.internal.imgLgLoaded && Media().init('mq-large') ) {
                // Load large image
                img.src = this.internal.imgLg;
                this.ui.imgLgEl.style.backgroundImage = 'url(' + img.src + ')' ;
                this.internal.imgLgLoaded = true;
            }

            img.onload = () => {
                this.ui.bgContainer.classList.add('is-loaded');
            };
        }
    }
}

export default FullBgCta;
